export default __webpack_public_path__ + "static/media/logoGoldMaq.6fbc0003.jpg";